import { Avatar } from "primereact/avatar";
import React from "react";

function getInitials(name) {
    if (!name) return "?";
    const parts = name.trim().split(" ");
    return parts.map((p, id) => p.substring(0, id + 1)).join("");
}
// Utility function
function getContrastTextColor(bgColor) {
    // Remove hash if present
    const color = bgColor.replace("#", "");

    // Convert shorthand hex (#fff) to full form (#ffffff)
    const fullHex = color.length === 3
        ? color.split("").map(c => c + c).join("")
        : color;

    // Convert hex to RGB
    const r = parseInt(fullHex.substr(0, 2), 16);
    const g = parseInt(fullHex.substr(2, 2), 16);
    const b = parseInt(fullHex.substr(4, 2), 16);

    // Calculate relative luminance (WCAG formula)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // If luminance is high → use black, else white
    return luminance > 0.5 ? "#000000" : "#FFFFFF";
}

export const renderAvatar = (user, marginRight = 0, zIndex = 1, skipInitials = false, size = "normal") => {
    if (user._id === 'all' || user._id === 'null') return "";
    // Color configuration
    const userBackground = "#e5e7eb";
    const institutionBackground = "#0173b1";
    const institutionText = "#fff";

    // Determine colors based on user type
    const isInstitution = Object.prototype.hasOwnProperty.call(user, "description");
    const textColor = isInstitution ? institutionText : getContrastTextColor(user.color ? '#' + user.color : userBackground);
    const backgroundColor = isInstitution ? institutionBackground : (user.color ? '#' + user.color : userBackground);

    const avatarStyle = {
        marginRight: `${marginRight}rem`,
        zIndex,
        border: '2px solid white',
        backgroundColor,
        color: textColor,
        fontSize: '0.9rem'
    };

    return user.image ? (
        <Avatar
            image={user.image}
            shape="circle"
            size={size}
            className="text-black"
            style={avatarStyle}
            key={zIndex}
        />
    ) : (
        <Avatar
            label={skipInitials ? user.name : getInitials(user.name)}
            shape="circle"
            size={size}
            className="text-black"
            style={avatarStyle}
            key={zIndex}
        />
    );
};

const renderAvatarLabel = (label, marginRight = 0, zIndex = 1) => {
    const user = {
        image: null,
        name: label,
    };
    return renderAvatar(user, marginRight, zIndex, true);
};

export const renderAvatarRow = (users, spacing = 0.75) => {
    const maxVisible = 3;

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ position: 'relative', display: 'flex' }}>
                {users.slice(0, maxVisible).map((user, index) => {
                    const margin = index < maxVisible - 1 ? -spacing : 0;
                    const isLastVisible = index === maxVisible - 1;

                    // jeśli jest więcej userów niż maxVisible → pokaż label zamiast ostatniego avatara
                    if (isLastVisible && users.length > maxVisible) {
                        return renderAvatarLabel(`+${users.length - maxVisible + 1}`, margin, maxVisible - index);
                    }

                    return renderAvatar(user, margin, maxVisible - index);
                })}
            </div>
        </div>
    );
};
